<template>
    <div class="CAcon">
        <ca-activation
            type="primary" 
            class="CAbtn"
            icon="el-icon-lock" 
            @click="CAlogin">
            CA登录
        </ca-activation>

        <p>
            <a 
                :href="calc" 
                target="_blank" 
                style="color:rgb(255, 0, 0);font-size: 16px;">
                CA登录绑定流程
            </a>
        </p>

        <p>
            <a 
                :href="qudong" 
                target="_blank" 
                style="color: #a25ab6;font-size: 16px;">
                电子招投标数字证书助手
            </a>
        </p>
    </div>
</template>

<script>
import CaActivation from '@/components-sys/ca-activation'
import '@/js/ca/allCA/hebcaWebSeal.js'
export default {
    components: {
        CaActivation,
    },
    props: {
        source: {
            type: String,
            default: ''
        },
        roleCode: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        calc:window._config.calc,
        qudong:window._config.qudong,
        caObjectVal:{},
        form:{}
    }),
    methods: {
        // 回车登录
        CAlogin(type){
            var that = this;
            that.form.caType = type;
            that.form.userType = that.roleCode;
            that.caObjectVal.character = that.source;
            // 签名
            useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                that.form.sData = res.signData;
                //获取证书对象
                useCA(that.form.caType, 'getCertB64', that.caObjectVal, function (res) {
                    that.form.sCert = res.signCert;
                    useCA(that.form.caType, 'CAterm', that.caObjectVal, function (res) {
                        that.form.sYxq = res.dYxq;
                        //将结果data提交后台
                        $.post(`${that.$store.getters.ageUrl}/admin/caloginnew.json`, that.form, function (data, res) {
                            if(data.result){
                                // 调用store.js的calogin方法
                                that.$store.dispatch('views/login',{obj:data.tdata});
                            }else{
                                ShowMsg(data.msg,'error')
                            }
                        })
                    })
                })
            })
        },
        login(cb){
            var that = this;
            $.post(`${that.$store.getters.ageUrl}/admin/caloginnew.json`, that.form, function (data, res) {
                if(data.result){
                    // 调用store.js的calogin方法
                    that.$store.dispatch('views/login',{obj:data.tdata});
                }else{
                    !!cb ? cb() : ShowMsg(data.msg,'error');
                }
            })
        },
        newCaLogin(type){
            var that = this;
            that.form.caType = type;
            that.form.userType = that.roleCode;
            that.form.orignal = that.source;
            //选择证书
            that.SelectSignCert();
            //获取b64证书
            that.GetCertB64(function(cert){
                that.form.cert = cert;
                that.form.sCert = cert;
                //签名
                that.Sign(that.source, function(signature){
                    that.form.signature = signature;
                    that.form.sData = signature;
                    //获取证书到期时间
                    that.GetSignCertNotAfter(0,function(certNotAfter){
                        that.form.sYxq = new Date(certNotAfter).toLocaleDateString();
                        //登录  如果登录成功 直接跳转页面
                        that.login(function(){
                            //登录失败  进行CA单位绑定  获取企业信息
                            $.ajax({
                                url:"/api/ca_mutual_recognition/getCertUnique.json",
                                type:"post",
                                data:that.form,
                                success:function(data){
                                    var jsonData = JSON.parse(decodeURI(data));
                                    if(jsonData.status != '1'){
                                        ShowMsg(jsonData.msg,'error');
                                        return
                                    }
                                    //绑定企业信息
                                    $.ajax({
                                        url:"/api/ca_mutual_recognition/calogin.json",
                                        type:"post",
                                        data:{
                                            canum:"1",
                                            carowguid:jsonData.data.cert_unique,//jsonData.data.cert_unique 柳梧新区金腾科技有限公司824535
                                            methodname:'getHuiYuanInfoByCA',
                                            identity:"18",
                                        },
                                        success:function(data){
                                            if(data.result){
                                                //绑定成功  重新尝试登录
                                                that.login();
                                            }else{
                                                ShowMsg(data.msg,'error')
                                            }
                                        }
                                    })
                                }
                            })
                        })
                    })
                });
            })
        },
    },
}
</script>

<style scoped lang="scss">
    .CAcon .CAbtn{ width:100%;height:45px;margin-top:35px; display: block; }
    .CAcon /deep/ .el-button{ width: 100% !important; }
    .CAcon p{ margin-top: 15px; text-align:right }
</style>